import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { changePasswordApi } from '../api/api'

export default function ChangePassword() {
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [msg, setMsg] = useState('')
  const nav = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMsg('')
    if(newPassword !== confirmPassword){
      setMsg('New Password and Confirm Password do not match.');
      return;
    }

    try {
      let res = await changePasswordApi({ oldPassword, newPassword, confirmPassword })
      if(res.data.code === 200){
        setMsg(res.data.message || 'Password changed successfully.')
        setOldPassword(''); setNewPassword(''); setConfirmPassword('');
        nav('/login');
      } else {
         throw new Error(res.data.message || 'Failed to change password.')
      }
    } catch {
      setMsg('Failed to change password.')
    }
  }

  return (
     <div className="row justify-content-center">
          <div className="col-12 col-sm-12 col-md-10 col-lg-8">
            <div className="card shadow-sm mb-3">
              <form className="rounded-3 p-1 p-md-3" onSubmit={handleSubmit}>
                <h4 className="mb-3">Change Password</h4>
                {/* Cash, UPI, Cheque Amount */}
                <div className="row g-2 mb-3">
                  <div className="col-12">
                    <label className="form-label mb-1 d-none d-sm-block">Old Password</label>
                    <input type="password" value={oldPassword} placeholder="Old Password" onChange={(e) => setOldPassword(e.target.value)} required />
                  </div>
                  <div className="col-12">
                    <label className="form-label mb-1 d-none d-sm-block">New Password</label>
                    <input type="password" value={newPassword} placeholder="New Password" onChange={(e) => setNewPassword(e.target.value)} required />
                  </div>
                  <div className="col-12">
                    <label className="form-label mb-1 d-none d-sm-block">Confirm New Password</label>
                    <input type="password" value={confirmPassword} placeholder="Enter New Password Again" onChange={(e) => setConfirmPassword(e.target.value)} required />
                  </div>
                </div>
    
                {/* Action Button */}
                <div className="d-grid">
                  <button className='btn btn-success' type="submit">Update</button>
                </div>
                {msg && <div className="text-center mt-2 fw-bold text-danger">{msg}</div>}
              </form>
            </div>
          </div>
        </div>
  )
}
